import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { CartProvider } from './contexts/CartContext';
import { AuthProvider } from './contexts/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import Home from './pages/Home';
import Catalog from './pages/Catalog';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import Compare from './pages/Compare';
import AdminPanel from './pages/AdminPanel';
import './App.css';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Hook para carregar favicon dinamicamente
const useDynamicFavicon = () => {
  useEffect(() => {
    const loadFavicon = async () => {
      try {
        const response = await fetch(`${API_URL}/api/public/settings`);
        if (response.ok) {
          const data = await response.json();
          const faviconUrl = data?.favicon?.url;
          if (faviconUrl) {
            // Remove favicon antigo
            const existingFavicon = document.querySelector('link[rel="icon"]');
            if (existingFavicon) {
              existingFavicon.remove();
            }
            // Adiciona novo favicon com cache busting
            const link = document.createElement('link');
            link.rel = 'icon';
            link.href = `${faviconUrl}?v=${Date.now()}`;
            document.head.appendChild(link);
          }
        }
      } catch (error) {
        console.error('Error loading favicon:', error);
      }
    };
    loadFavicon();
  }, []);
};

// Componente para esconder Navbar/Footer nas rotas admin
const AppLayout = ({ children }) => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin1020');
  
  // Carrega favicon dinâmico
  useDynamicFavicon();

  return (
    <div className="App min-h-screen flex flex-col">
      {!isAdminRoute && <Navbar />}
      <main className="flex-grow">
        {children}
      </main>
      {!isAdminRoute && <Footer />}
      {!isAdminRoute && <WhatsAppButton />}
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <AppLayout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/catalogo" element={<Catalog />} />
              <Route path="/produto/:id" element={<ProductDetail />} />
              <Route path="/carrinho" element={<Cart />} />
              <Route path="/comparar" element={<Compare />} />
              {/* Rota oculta do admin - NÃO aparece em menus */}
              <Route path="/admin1020" element={<AdminPanel />} />
            </Routes>
          </AppLayout>
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
